export default __webpack_public_path__ + "static/media/been.4bd768ba.jpg";